// @flow

import styled from 'styled-components';
import { LIGHT } from '../../../helpers/fontWeight';
import type { Theme } from '../../../types';

const Content = styled<any, Theme>('div')`
  font-size: ${props => props.theme.wysiwyg.fontSize};
  line-height: 1.5em;
  max-width: 100%;
  width: 100%;
  font-weight: ${LIGHT};

  *:last-child {
    margin-bottom: 0;
  }

  table {
    width: 100%;
  }
  iframe {
    width: 100%;
  }
`;

export default Content;
